import { Trans, useTranslation } from "react-i18next";

import { getSegmentChangeVariant } from "../changeVariant";

import {
  HistoryEntryCard,
  type EntityHistoryEntry,
} from "@/components/ui/v2/history";

export function SegmentCreatedHistoryItem({
  entry,
}: {
  entry: EntityHistoryEntry;
}) {
  const { t } = useTranslation();
  const actor = t("history.actor.system");
  return (
    <HistoryEntryCard
      occurredAt={entry.occurredAt}
      description={
        <Trans
          i18nKey="history.line1.segmentCreated"
          values={{ actor }}
          components={{ b: <strong className="font-semibold" /> }}
        />
      }
      variant={getSegmentChangeVariant(entry.changeType)}
    />
  );
}
